import { render, staticRenderFns } from "./reminderTypesTable.vue?vue&type=template&id=73970da3"
import script from "./reminderTypesTable.vue?vue&type=script&lang=js"
export * from "./reminderTypesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports